import { render, staticRenderFns } from "./ModalLabelDelete.vue?vue&type=template&id=a821b70a&"
import script from "./ModalLabelDelete.vue?vue&type=script&lang=js&"
export * from "./ModalLabelDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports